/* eslint-disable no-console */
import Cookies from 'js-cookie';
import SvgIcon from '@png/npm-svg-icon';
import ApiManager from '../api/crud-manager';
// eslint-disable-next-line import/no-cycle
import ProductList from './catalog/product-list'; // TODO: check no-cycle error

/**
 * Class product Favorite module
 * @class
 * @author Max Swinkels <max.swinkels@pangaea.nl>
 *
 * See the manual for more information and implementation
 * https://pangaeanl.atlassian.net/wiki/spaces/PD/pages/1159135233/Favorieten+module\
 *
 * issue
 * https://pangaeanl.atlassian.net/browse/PNGI-449
 */

class ProductFavorite {
  constructor(options = {}) {
    this.config = {
      toggleModuleList: () => document.querySelectorAll('[data-module="ProductFavoriteToggle"]'),
      listModule: () => document.querySelector('[data-module="ProductFavoritesList"]'),
      listEmptyModule: document.querySelector('[data-module="ProductFavoritesListEmptyMessage"]'),
      amountModule: document.querySelectorAll('[data-module="ProductFavoritesAmount"]'),
      favoritesItems: () => document.querySelectorAll('[data-product-favorites-list-item]'),
      favoriteListArray: [],
      hasPreferenceObject: false,
      debounce: null,
      debounceTimeOut: 300,
      token: Cookies.get('token'),
      apiManager: new ApiManager(),
      ...options
    };
  }

  // get user preference and return array of users productFavorites
  getFavorites() {
    const { apiManager } = this.config;

    return apiManager
      .get('/api/v2/preference/user?key=productFavorites')
      .then(response => {
        // return null if user preferences is empty
        if (!response.length) {
          return null;
        }

        // return empty array if response has nu data
        if (!response[0].value) {
          return [];
        }

        // decode and parse data to json, then return
        return JSON.parse(decodeURI(response[0].value));
      })
      .catch(e => {
        console.error(e);
      });
  }

  // update user preferences object in database with new data
  updateFavoritesList(array) {
    const { token, apiManager } = this.config;

    // debounce to prevent multiple API calls on spam click
    clearTimeout(this.config.debounce);
    this.config.debounce = window.setTimeout(() => {
      // convert array to encoded json string if not empty
      const json = array.length ? encodeURI(JSON.stringify(array)) : '';

      // check if user is logged in, then run the process of the database update
      if (token) {
        // if the hasPreferenceObject is false, create new user preference object in databsae. Otherwise update it with new value
        if (this.config.hasPreferenceObject) {
          const patchValue = JSON.parse(`[{"op":"replace","path":"/value","value":"${json}"}]`);
          apiManager
            .patch('/api/v2/preference/user/productFavorites', patchValue)
            .then(response => response)
            .catch(e => {
              console.info(e);
            });
        } else {
          const postValue = JSON.parse(
            `{"key":"productFavorites","value":"${json}","type":"string"}`
          );
          apiManager
            .post('/api/v2/preference/user', postValue)
            .then(response => response)
            .then(() => {
              this.config.hasPreferenceObject = true;
            })
            .catch(e => {
              console.error(e);
            });
        }
      }
    }, this.config.debounceTimeOut);
  }

  // adds new item to the favoritesList
  addFavorite(productItemcode, _element, disableToast = false) {
    const element = _element;

    const { favoriteListArray } = this.config;
    const itemIndex = favoriteListArray.indexOf(productItemcode);

    if (itemIndex > -1) {
      return;
    }

    // update array
    favoriteListArray.push(productItemcode);
    this.config.favoriteListArray = favoriteListArray;
    this.updateFavoritesList(favoriteListArray);

    // send toaster event
    if (!disableToast) {
      window.dispatchEvent(
        new CustomEvent('toast', {
          detail: {
            type: 'success',
            text: element.dataset.addedToastMessage || 'Product added to favorites'
          }
        })
      );
    }
  }

  // remove item from the favoritesList
  removeFavorite(productItemcode, _element, disableToast = false) {
    const element = _element;

    const { favoriteListArray, listModule, listEmptyModule } = this.config;
    const itemIndex = favoriteListArray.indexOf(productItemcode);

    if (itemIndex === -1) {
      return;
    }

    // update array
    favoriteListArray.splice(itemIndex, 1);
    this.config.favoriteListArray = favoriteListArray;
    this.updateFavoritesList(favoriteListArray);

    // send toaster event
    if (!disableToast) {
      window.dispatchEvent(
        new CustomEvent('toast', {
          detail: {
            type: 'success',
            text: element.dataset.removedToastMessage || 'Product removed from favorites'
          }
        })
      );
    }

    if (listModule()) {
      const btnContainer = listModule().querySelector('.btn-container');
      const unavailableTitle = listModule().querySelector('.c-productgrid--unavailable__title');
      const unavailableContainer = listModule().querySelector('.c-productgrid--unavailable');
      // if product is removed from the favorite list, remove the element.
      const listElement = element.closest('[data-product-favorites-list-item]');
      if (listElement) {
        listElement.parentNode.removeChild(listElement);
      }

      if (unavailableContainer && unavailableContainer.childElementCount <= 0) {
        if (btnContainer) btnContainer.classList.add('hidden');
        if (unavailableContainer) unavailableContainer.classList.add('hidden');
        if (unavailableTitle) unavailableTitle.classList.add('hidden');
      }

      // if favorite list is empty, display emty message module
      if (listEmptyModule && !favoriteListArray.length) {
        listEmptyModule.classList.remove('hidden');
      }
    }
  }

  renderFavoriteProductList() {
    const { listModule, listEmptyModule, favoriteListArray } = this.config;

    const element = listModule();

    if (!element) {
      return;
    }

    element.classList.add('is-loading');

    if (favoriteListArray.length) {
      const itemCodes = favoriteListArray.join(',');
      const template = 'FavoriteProducts';
      new ProductList().renderProductList(element, itemCodes, template);
    } else {
      // display list is empty module
      if (listEmptyModule) {
        listEmptyModule.classList.remove('hidden');
      }
      element.classList.remove('is-loading');
    }
  }

  // shows the number of favorite in the menu badge
  renderFavoriteAmount() {
    const { amountModule, favoriteListArray } = this.config;

    if (!amountModule) {
      return;
    }

    amountModule.forEach(_element => {
      const element = _element;
      const { style } = element;

      // show favorite amount badge
      if (favoriteListArray.length > 0) {
        style.display = 'inline-block';
      }

      // display favorite list array length
      element.innerHTML = favoriteListArray.length;
    });
  }

  async reRenderFavorites() {
    const { favoritesItems, token } = this.config;

    if (token) {
      await this.getFavorites()
        .then(data => {
          if (data != null) this.config.hasPreferenceObject = true;
          const list = data || [];

          this.config.favoriteListArray = list;
        })
        .catch(e => {
          console.error(e);
        });
    }

    const renderedProductCodes = Array.from(favoritesItems()).map(
      itemcode => itemcode.dataset.productId
    );

    const notRenderedProductCodes = this.config.favoriteListArray.filter(
      item => !renderedProductCodes.includes(item)
    );

    if (notRenderedProductCodes.length > 0) {
      this.renderRemovedProducts(notRenderedProductCodes);
    }

    this.renderFavoriteToggles();
  }

  static insertAfter(newNode, referenceNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
  }

  renderRemovedProducts(list) {
    if (list.length <= 0) return;

    const { listModule } = this.config;
    const listElement = listModule();
    if (!listElement) return;

    const existingGrid = listElement.querySelector('.c-productgrid');
    const grid = document.createElement('div');
    grid.classList.add('c-productgrid');
    grid.classList.add('c-productgrid--unavailable');

    const title = document.createElement('h4');
    title.classList.add('c-productgrid--unavailable__title');
    title.innerHTML = 'Unavailable products';

    if (existingGrid && existingGrid.dataset.empty === 'true') {
      existingGrid.innerHTML = '';
    }

    if (existingGrid) {
      ProductFavorite.insertAfter(grid, existingGrid);
      ProductFavorite.insertAfter(title, existingGrid);
    } else {
      listElement.prepend(title);
      listElement.prepend(grid);
    }

    const existingFavorite = listElement.querySelector('.c-product-favorite');
    const itemCodeText = listElement !== null ? listElement.dataset.itemCodeText : 'Item code';
    const itemRemovedText =
      listElement !== null ? listElement.dataset.itemRemovedText : 'Product not available';
    const addedToast =
      existingFavorite !== null
        ? existingFavorite.dataset.addedToastMessage
        : 'Product added to favorites';
    const removedToast =
      existingFavorite !== null
        ? existingFavorite.dataset.removedToastMessage
        : 'Product removed from favorites';

    list.forEach(item => {
      const htmlString = `<div class="c-productcard">
                            <div class="c-productname">
                              ${itemCodeText}: ${item} <br /> ${itemRemovedText}
                            </div>
                            <div class="c-productcard__favorite">
                                <div class="c-product-favorite"
                                        data-module="ProductFavoriteToggle"
                                        data-product-itemcode="${item}"
                                        data-added-toast-message="${addedToast}"
                                        data-removed-toast-message="${removedToast}"></
                                        }">
                                    <div class="checkbox checkbox--favorite">
                                        <input type="checkbox" name="favorite-toggle" id="favorite-toggle-${item}" value="${item}">
                                        <label for="favorite-toggle-${item}" class="c-favoritetoggle">
                                            <img src="/dist/images/icons/favorite.svg" class="c-favoritetoggle__icon" data-module="SvgIcon" />
                                        </label>
                                    </div>

                                </div>

                            </div>
                        </div>`;
      const container = document.createElement('div');
      container.classList.add('c-productgrid__item');
      container.dataset.productId = item;
      container.dataset.productFavoritesListItem = '';
      container.innerHTML = htmlString.trim();

      grid.appendChild(container);
    });
    new SvgIcon().init();
  }

  // shows the favorite toggles in the product list items or on detail page
  async renderFavoriteToggles() {
    const { toggleModuleList } = this.config;

    toggleModuleList().forEach(_element => {
      const element = _element;
      const { initialized } = element.dataset;
      if (initialized != null && initialized) return;

      element.dataset.initialized = true;

      this.initialStatus(element);
      element.classList.remove('hidden');
      this.handleClick(element);
    });
  }

  // checks if element is inside favoriteListArray, then set as active item
  initialStatus(_element) {
    const element = _element;
    const checkbox = element.querySelector('input[type="checkbox"]');
    const { favoriteListArray } = this.config;

    if (!checkbox && checkbox.value) {
      return;
    }

    const productItemcode = checkbox.value;
    if (favoriteListArray.includes(productItemcode)) {
      checkbox.checked = true;
    }
  }

  // handle the onclick of the favorite toggle
  handleClick(_element) {
    const element = _element;
    const checkbox = element.querySelector('input[type="checkbox"]');

    if (!checkbox && checkbox.value) {
      return;
    }

    checkbox.addEventListener('change', () => {
      const productItemcode = checkbox.value;
      if (checkbox.checked) {
        this.addFavorite(productItemcode, element);
      } else {
        this.removeFavorite(productItemcode, element);
        if (checkbox.dataset.parentId) {
          this.removeFavorite(checkbox.dataset.parentId, element, true);
        }
      }

      // trigger favorite amount to display new value
      this.renderFavoriteAmount();
    });
  }

  init() {
    const { token } = this.config;

    const initialSetup = () => {
      // if my account favorite module is present, render the product list
      this.renderFavoriteProductList();

      // if any product favorite toggle module is present, render render the handler
      this.renderFavoriteToggles();

      // counts favorite list and display amount in navbar
      this.renderFavoriteAmount();
    };

    // check if user is logged in
    if (token) {
      this.getFavorites()
        .then(data => {
          if (data != null) {
            // sets global value to create or update a user preference row in the database
            this.config.hasPreferenceObject = true;
          }

          const list = data || [];

          // set merged arrays as globaly variable
          this.config.favoriteListArray = list;

          // trigger all initial functions
          initialSetup();
        })
        .catch(e => {
          console.error(e);
        });
    }
  }
}

export default ProductFavorite;
